export const GET_INGREDIENTS_REQUEST = 'GET_INGREDIENTS_REQUEST';
export const GET_INGREDIENTS_SUCCEED = 'GET_INGREDIENTS_SUCCEED';
export const GET_INGREDIENTS_FAIL = 'GET_INGREDIENTS_FAIL';

export const PLACE_ORDER_REQUEST = 'PLACE_ORDER_REQUEST';
export const PLACE_ORDER_SUCCEED = 'PLACE_ORDER_SUCCEED';
export const PLACE_ORDER_FAIL = 'PLACE_ORDER_FAIL';

export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCEED = 'GET_ORDER_SUCCEED';
export const GET_ORDER_FAIL = 'GET_ORDER_FAIL';
export const GET_ORDER_404 = 'GET_ORDER_404';

export const REGISTER_SUCCEED = 'REGISTER_SUCCEED';
export const REGISTER_FAILED = 'REGISTER_FAILED';

export const LOGIN_SUCCEED = 'LOGIN_SUCCEED';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGOUT_SUCCEED = 'LOGOUT_SUCCEED';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const GET_USER_FAIL = 'GET_USER_FAIL';
export const REFRESH_TOKEN_FAIL = 'REFRESH_TOKEN_FAIL';

export const REQUEST_CODE_SUCCEED = 'REQUEST_CODE_SUCCEED';
export const REQUEST_CODE_FAILED = 'REQUEST_CODE_FAILED';

export const RESET_PASSWORD_SUCCEED = 'RESET_PASSWORD_SUCCEED';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const UPDATE_PROFILE_SUCCEED = 'UPDATE_PROFILE_SUCCEED';
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED';

export const DISMISS_ERROR = 'DISMISS_ERROR';
export const CLOSE_SUCCESS = 'CLOSE_SUCCESS';
export const CLEAR_404 = 'CLEAR_404';

export const WS_ERROR = 'WS_ERROR';

export const ERROR_500 = 'ERROR_500';
